import { createFileRoute } from "@tanstack/react-router";
import { CapturarCodigoPage } from "@/paginas/pg_camera/camera-capturar-codigo";

export const Route = createFileRoute("/_authenticated/camera-capturar-codigo")({
  head: () => ({
    meta: [
      { title: "Capturar código — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Leia códigos de barras, QR-Codes ou anexe fotos e envie para a fila compartilhada da equipe.",
      },
      { property: "og:title", content: "Capturar código — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Leitura de códigos de barras, QR-Code e envio de fotos para a equipe.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: CapturarCodigoPage,
});
